<mat-chip
  class="ai-chatbot-category-chip"
  [class.ai-chatbot-category-chip-selected]="
    selectedValue || selectedValues?.size
  "
  [class.ai-chatbot-category-chip-display]="isDisplayOnly"
  [matMenuTriggerFor]="categoryMenu"
  tabindex="0"
  (keydown)="onKeydown($event)"
  [disabled]="isDisplayOnly"
>
  <mat-icon
    *ngIf="!selectedOption?.icon"
    [svgIcon]="icon"
    class="ai-chatbot-category-chip-icon"
    [class]="'ai-chatbot-category-chip-icon-' + label.toLowerCase()"
  ></mat-icon>
  <mat-icon
    *ngIf="selectedOption?.icon"
    [svgIcon]="selectedOption?.icon"
    class="ai-chatbot-category-chip-selected-icon"
  ></mat-icon>
  {{ selectedOption ? selectedOption.name : label }}
  {{ selectedValues?.size > 1 ? "+" + (selectedValues.size - 1) : "" }}
  <mat-icon
    *ngIf="!isDisplayOnly"
    svgIcon="chevron-down"
    class="ai-chatbot-category-chip-chevron"
  ></mat-icon>
</mat-chip>
<mat-menu class="ai-chatbot-category-chip-menu" #categoryMenu="matMenu">
  <button
    mat-menu-item
    class="ai-chatbot-category-chip-menu-item"
    [class.selected]="isSelected(option)"
    *ngFor="let option of options"
    (click)="onOptionClick(option)"
    (keydown)="onMenuItemKeydown($event, option)"
  >
    <span *ngIf="!isMultiSelect">{{ option.name }}</span>
    <mat-checkbox
      *ngIf="isMultiSelect"
      [checked]="isSelected(option)"
      (click)="$event.stopPropagation()"
      (change)="onOptionClick(option)"
      labelPosition="before"
    >
      <mat-icon *ngIf="option.icon" [svgIcon]="option.icon"></mat-icon>
      <span>{{ option.name }}</span>
    </mat-checkbox>
  </button>
</mat-menu>
